import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
const SEASONAL = [{
  title: 'Kaiju No. 8',
  image: 'https://images.unsplash.com/photo-1618336753974-aae8e04506aa?q=80&w=800&auto=format&fit=crop',
  airing: 'Today'
}, {
  title: 'Demon Slayer: Hashira Training',
  image: 'https://images.unsplash.com/photo-1542451313056-b7c8e626645f?q=80&w=800&auto=format&fit=crop',
  airing: 'Tomorrow'
}, {
  title: 'Solo Leveling S2',
  image: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=800&auto=format&fit=crop',
  airing: 'Wed'
}, {
  title: 'Oshi no Ko S2',
  image: 'https://images.unsplash.com/photo-1493225457124-a1a2a5bf994e?q=80&w=800&auto=format&fit=crop',
  airing: 'Thu'
}, {
  title: 'Mushoku Tensei S2 P2',
  image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=800&auto=format&fit=crop',
  airing: 'Fri'
}, {
  title: 'Blue Lock: Episode Nagi',
  image: 'https://images.unsplash.com/photo-1518066000714-58c45f1a2c0a?q=80&w=800&auto=format&fit=crop',
  airing: 'Sat'
}];
export function NewThisSeason() {
  return <section className="py-8 border-t border-white/5" data-id="element-63">
      <div className="flex items-center justify-between mb-6" data-id="element-64">
        <h2 className="text-xl font-serif text-white/90" data-id="element-65">
          New this Season{' '}
          <span className="text-white/40 italic text-lg" data-id="element-66">— Spring 2026</span>
        </h2>
        <button className="text-xs font-medium text-rose-500 hover:text-rose-400 transition-colors" data-id="element-67">
          View All
        </button>
      </div>

      <div className="relative" data-id="element-68">
        {/* Fade edges for scroll affordance */}
        <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" data-id="element-69" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-black via-black/80 to-transparent z-10 pointer-events-none flex items-center justify-end pr-4" data-id="element-70">
          <div className="w-8 h-8 rounded-full bg-white/10 backdrop-blur flex items-center justify-center text-white/50" data-id="element-71">
            →
          </div>
        </div>

        <div className="flex gap-4 overflow-x-auto hide-scrollbar pb-4 -mx-6 px-6" data-id="element-72">
          {SEASONAL.map((anime, idx) => <motion.div key={anime.title} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.5 + idx * 0.1
        }} className="flex-none w-40 group cursor-pointer" data-id="element-73">
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-dark border border-white/5 mb-3 group-hover:border-rose-500/30 transition-colors" data-id="element-74">
                <img src={anime.image} alt={anime.title} className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-75" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-76" />

                {anime.airing === 'Today' && <div className="absolute top-2 right-2 px-2 py-1 rounded bg-rose-500 text-[10px] font-bold text-white uppercase tracking-wider shadow-[0_0_10px_rgba(244,63,94,0.5)]" data-id="element-77">
                    New Ep
                  </div>}
              </div>

              <h4 className="text-sm font-medium text-white/90 truncate group-hover:text-rose-400 transition-colors" data-id="element-78">
                {anime.title}
              </h4>
              <div className="flex items-center gap-1.5 text-xs text-white/50 mt-1" data-id="element-79">
                <Calendar className="w-3 h-3" data-id="element-80" />
                Airs {anime.airing}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}